export type BaseDadosCategoria = "ESTRUTURA" | "TIPOS_OBRA";

export const BASE_DADOS_TITULO = "Base de dados";
export const DESCRICAO_ESTRUTURA =
  "Estrutura usada no Nova Obra e no Adicionar Escopo macro: tipo de obra, grupo e subgrupo. Os escopos de cada linha são cadastrados em Escopos macro padrão.";
export const DESCRICAO_TIPOS_OBRA =
  "Tipos de obra que vêm do Proteus. Só os ativos aparecem no Nova Obra, no Adicionar da Plan. Controle e na Estrutura.";
export const BASE_DADOS_AVISO_TIPOS_OBRA =
  "Lista que vem do Proteus. Aqui você ativa ou inativa os tipos de obra usados no Hub.";
export const BASE_DADOS_MENU_LABEL = "Listas de referência";

export const BASE_DADOS_CATEGORIAS: readonly { valor: BaseDadosCategoria; rotulo: string }[] = [
  { valor: "ESTRUTURA", rotulo: "Estrutura" },
  { valor: "TIPOS_OBRA", rotulo: "Tipos de Obra" },
];

export const BASE_DADOS_MOSTRAR_INATIVOS_LABEL = "Mostrar inativos";
export const BASE_DADOS_NOVO_GRUPO_LABEL = "Novo grupo";
export const BASE_DADOS_INATIVAR_LABEL = "Inativar";
export const BASE_DADOS_ATIVAR_LABEL = "Ativar";

export const BASE_DADOS_SITUACAO_ATIVO = "Ativo";
export const BASE_DADOS_SITUACAO_INATIVO = "Inativo";
export const BASE_DADOS_SEM_VALOR = "—";

export const BASE_DADOS_FORBIDDEN_MESSAGE =
  "Você não tem permissão para consultar a Base de dados.";
export const BASE_DADOS_ERROR_MESSAGE = "Não foi possível carregar a Base de dados.";
export const BASE_DADOS_LOADING_LABEL = "Carregando Base de dados...";
export const BASE_DADOS_VAZIO_TITULO = "Nenhum registro encontrado";
export const BASE_DADOS_VAZIO_DESCRICAO = "Não há registros nesta lista.";

export interface BaseDadosColuna {
  campo: string;
  rotulo: string;
}

export const COLUNAS_ESTRUTURA: readonly BaseDadosColuna[] = [
  { campo: "tipoObra", rotulo: "Tipo de obra" },
  { campo: "grupo", rotulo: "Grupo" },
  { campo: "subgrupo", rotulo: "Subgrupo" },
  { campo: "escopos", rotulo: "Escopos macro padrão" },
  { campo: "situacao", rotulo: "Situação" },
];

export const COLUNAS_TIPOS_OBRA: readonly BaseDadosColuna[] = [
  { campo: "codigo", rotulo: "Código" },
  { campo: "nome", rotulo: "Tipo de obra" },
  { campo: "grupos", rotulo: "Grupos" },
  { campo: "situacao", rotulo: "Situação" },
];

export const DESCRICAO_POR_CATEGORIA: Record<BaseDadosCategoria, string> = {
  ESTRUTURA: DESCRICAO_ESTRUTURA,
  TIPOS_OBRA: DESCRICAO_TIPOS_OBRA,
};

export const COLUNAS_POR_CATEGORIA: Record<BaseDadosCategoria, readonly BaseDadosColuna[]> = {
  ESTRUTURA: COLUNAS_ESTRUTURA,
  TIPOS_OBRA: COLUNAS_TIPOS_OBRA,
};

export interface MensagemToast {
  resumo: string;
  detalhe?: string;
}

const listaDeTipos = (codigos: readonly string[]) => codigos.join(" e ao ");

/** Toasts de sucesso (Figma 15567:1935670, 15577:803329, 15577:804410, 15579:1517095 e 15579:1517224): só o resumo, sem título. */
export const TOASTS = {
  grupoAdicionado103: (grupo: string): MensagemToast => ({
    resumo: `Grupo ${grupo} adicionado ao 103.`,
    detalhe: "Cadastre os escopos padrão dele.",
  }),
  grupoAdicionadoDocagem: (grupo: string, codigos: readonly string[]): MensagemToast => ({
    resumo: `Grupo ${grupo} adicionado ao ${listaDeTipos(codigos)}.`,
  }),
  subgrupoInativado: (subgrupo: string, grupo: string): MensagemToast => ({
    resumo: `Subgrupo ${subgrupo} do ${grupo} inativado.`,
  }),
  subgrupoReativado: (subgrupo: string, grupo: string): MensagemToast => ({
    resumo: `Subgrupo ${subgrupo} do ${grupo} reativado.`,
  }),
  grupoInativado: (grupo: string): MensagemToast => ({ resumo: `Grupo ${grupo} inativado.` }),
  grupoReativado: (grupo: string, comSubgrupos: boolean): MensagemToast => ({
    resumo: comSubgrupos ? `Grupo ${grupo} e subgrupos reativados.` : `Grupo ${grupo} reativado.`,
  }),
  tipoInativado: (codigo: string): MensagemToast => ({
    resumo: `Tipo de obra ${codigo} inativado.`,
  }),
  tipoAtivado: (codigo: string): MensagemToast => ({ resumo: `Tipo de obra ${codigo} ativado.` }),
};

/** Erros: o texto do servidor vale; estes entram quando ele não vem. */
export const ERROS = {
  duplicidade: (grupo: string, codigo: string) => `Já existe um grupo ${grupo} no ${codigo}.`,
  generico: () => "Não foi possível concluir a operação.",
};
